import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  OptimizationHistoryPage,
  OptimizationHistoryQuery
} from '@core/models/optimization-history.model';

export const OptimizationHistoryActions = createActionGroup({
  source: 'Optimization History',
  events: {
    Load: props<{ query: OptimizationHistoryQuery }>(),
    'Load Success': props<{ page: OptimizationHistoryPage }>(),
    'Load Failure': emptyProps(),
    'Page Entered': emptyProps(),
    'Page Left': emptyProps()
  }
});
